import React from 'react';
import { Container, Row, Input, Label } from 'reactstrap';

function Sizes({ creatives = [], selectedSizes = [], handleSelect, isSelectedAll = true, selectAll = () => { }, deselectAll = () => { }, isChecked = (item, idx) => { }, columnWidth = "3" }) {
  return (
    <Container>
      <Row>
        <div className='p-0 w-100 d-flex align-items-center justify-content-between'>
          <span>Sizes</span>
          {isSelectedAll ?
            <button className='btn btn-light' onClick={deselectAll}>Deselect All</button>
            :
            <button className='btn btn-soft-info' onClick={selectAll}>Select All</button>
          }
        </div>
      </Row>
      <Row>
        {(creatives || []).map((item, idx) => {
          const checkedBool = isChecked(item, idx);
          return (
            <div className={`col-${columnWidth} d-flex justify-content-start form-check form-check-primary mt-3`} key={idx}>
              <Input
                className='form-check-input bg-light border-0 me-1'
                type='checkbox'
                name={item.size + "-" + idx}
                id={item.size + "-" + idx}
                onChange={() => handleSelect(item, idx)}
                checked={(checkedBool || false)}
              />
              <Label className='fw-normal' for={item.size + "-" + idx}>{item.size}</Label>
            </div>
          )
        })}
      </Row>
    </Container >

  )
}

export default Sizes
